import { useState } from 'react';

const CustomColorSelect = ({defaultColor,setColorSelect, index, label, name}) => {
    const [copySuccess, setCopySuccess] = useState(null);
    
    const copyToClipBoard = async text => {
        try {
          await navigator.clipboard.writeText(text);
          setCopySuccess(`Copied! ${text}`);
          setTimeout(() => {
            setCopySuccess(null);
          }, 3000);
        } catch (err) {
          setCopySuccess('Failed to copy!');
          setTimeout(() => {
            setCopySuccess(null);
          }, 3000);
        }
      };

    const handleChange = (e) => {
        setColorSelect(e.target.value, 'color')
    }

    return ( 
        <div className='relative flex flex-col w-32 gap-1'>
            <label htmlFor={`color-${index}`} className="col-span-1 text-sm text-gray-500">{label}</label>
            <input onChange={handleChange}  value={defaultColor} required type="color" name={`color-${index}`} className="w-full h-[34px] rounded-md" placeholder="_ac_energy"/>
        {defaultColor ?
                <button type='button' id={`copy-color-${index}`}  className='text-[10px] absolute -bottom-1 w-full text-center'
            onClick={()=>copyToClipBoard(defaultColor)}>
                {copySuccess?copySuccess: `click to Copy ${defaultColor}`} 
                </button>:
                <span className='text-[10px] absolute -bottom-1 w-full'>Pick a color</span>
            }

        </div>
     );
}
 
export default CustomColorSelect;